import { createApp } from 'vue'
import App from './App.vue'
import { installClickTracker } from './analytics';
import router from './router';

import axios from 'axios'
import { Buffer } from 'buffer'

window.Buffer = Buffer;

axios.defaults.baseURL = 'https://www.pathtracer.io/api'
axios.defaults.headers.post['Content-Type'] = 'application/json'

axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('token');
  
        // Use Vue Router for navigation
        router.push('/login');
  
        return Promise.reject(error);
      }
  
      return Promise.reject(error);
    }
  );
  // record current route name for analytics context
router.afterEach((to) => { window.__lastRouteName = to.name || null; });

installClickTracker();  // one line, global
// Optionally send cookies/session data 
// axios.defaults.withCredentials = true

const app = createApp(App)
app.use(router)
app.mount('#app')
